module.exports = __webpack_public_path__ + "img/img5.707377e3.png";